export default [
  {
    path: '/admin/clusters',
    name: 'indexRegionAdmin',
    meta: { title: 'indexRegionAdmin' },
    component: () => import('@/pages/admin/regions'),
  },
]
